import React from 'react'
import {CSSTransition} from 'react-transition-group'
// import LoaderSvg from './loader.svg'
class Loader extends React.Component{
	render(){
		return(
			<CSSTransition
				in={this.props.in}
                timeout={600}
                classNames="long-fade"
                mountOnEnter={true}
                unmountOnExit={true}
                >
			<div className="Loader small-type" >
				<strong>Julian Salinas Fotografie</strong>
			</div>
		</CSSTransition>
		)
	}
}

export default Loader
				// <img src={LoaderSvg} alt="...loading" />


// WEBPACK FOOTER //
// ./src/Loader.js